var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "agreement"
    }
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.loadingTable
    }
  }, [_c("a-card", {
    staticStyle: {
      "border-top": "24px solid #f0f2f5"
    },
    attrs: {
      bordered: false,
      title: _vm.$t("pagesetting.title")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pagesetting.desccontent")) + "：")]), _vm.descContentList.length == 0 ? _c("div", {
    staticStyle: {
      padding: "12px 0"
    }
  }, [_c("a", {
    on: {
      click: function click($event) {
        return _vm.addSpecValueModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("pagesetting.addContent")))])]) : _vm._e(), _c("div", {
    staticStyle: {
      "padding-right": "60px",
      "flex-direction": "column"
    }
  }, _vm._l(_vm.descContentList, function (item2, index2) {
    return _c("div", {
      key: "contentList" + index2,
      staticStyle: {
        padding: "12px 0"
      }
    }, [_c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(item2.content) + " ")]), _c("span", {
      staticStyle: {
        "padding-right": "20px",
        width: "200px",
        display: "inline-block",
        "white-space": "nowrap",
        overflow: "hidden",
        "text-overflow": "ellipsis",
        "vertical-align": "bottom"
      }
    }, [_vm._v(_vm._s(item2.content))])], 2), _c("span", [_c("a", {
      on: {
        click: function click($event) {
          return _vm.editSpecValueBtn(index2);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("public.edit")))])]), _c("a-divider", {
      attrs: {
        type: "vertical"
      }
    }), _c("span", [_c("a-popconfirm", {
      attrs: {
        title: _vm.$t("public.deletePromp"),
        "ok-text": _vm.$t("public.confirm"),
        "cancel-text": _vm.$t("public.cancel")
      },
      on: {
        confirm: function confirm($event) {
          return _vm.deleteSpecValue(index2);
        }
      }
    }, [_c("a", [_vm._v(_vm._s(_vm.$t("public.delete")))])])], 1), _vm.descContentList.length - 1 == index2 ? _c("span", [_c("a-divider", {
      attrs: {
        type: "vertical"
      }
    }), _c("a", {
      on: {
        click: function click($event) {
          return _vm.addSpecValueModal();
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("pagesetting.addContent")))])], 1) : _vm._e()], 1);
  }), 0)])]), _c("a-card", {
    staticStyle: {
      "border-top": "24px solid #f0f2f5"
    },
    attrs: {
      bordered: false,
      title: _vm.$t("pagesetting.title2")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pagesetting.pdfUrl")) + "：")]), _c("div", {
    staticStyle: {
      "padding-right": "60px",
      "flex-direction": "column"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px 0"
    }
  }, [_c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.oldObj.catalogPdfUrl) + " ")]), _c("span", {
    class: [_vm.oldObj.catalogPdfUrl ? "catalogStyle" : ""]
  }, [_vm._v(_vm._s(_vm.oldObj.catalogPdfUrl))])], 2), _c("span", [_c("a", {
    on: {
      click: function click($event) {
        return _vm.editLog();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.edit")))])])], 1)])]), _c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pagesetting.url2")) + "：")]), _c("div", {
    staticStyle: {
      "padding-right": "60px",
      "flex-direction": "column"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px 0"
    }
  }, [_c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.oldObj.catalogPageUrl) + " ")]), _c("span", {
    staticStyle: {
      "padding-right": "20px",
      width: "200px",
      display: "inline-block",
      "white-space": "nowrap",
      overflow: "hidden",
      "text-overflow": "ellipsis",
      "vertical-align": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.oldObj.catalogPageUrl))])], 2)], 1)])])]), _c("a-card", {
    staticStyle: {
      "border-top": "24px solid #f0f2f5"
    },
    attrs: {
      bordered: false,
      title: _vm.$t("pagesetting.title3")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pagesetting.targetEmail")) + "：")]), _vm.contactDataList.length == 0 ? _c("div", {
    staticStyle: {
      padding: "12px 0"
    }
  }, [_c("a", {
    on: {
      click: function click($event) {
        return _vm.addTarget();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.add")))])]) : _vm._e(), _c("div", {
    staticStyle: {
      "padding-right": "60px",
      "flex-direction": "column"
    }
  }, _vm._l(_vm.contactDataList, function (item4, index4) {
    return _c("div", {
      key: "contentList" + index4,
      staticStyle: {
        padding: "12px 0"
      }
    }, [_c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(item4) + " ")]), _c("span", {
      staticStyle: {
        "padding-right": "20px",
        width: "200px",
        display: "inline-block",
        "white-space": "nowrap",
        overflow: "hidden",
        "text-overflow": "ellipsis",
        "vertical-align": "bottom"
      }
    }, [_vm._v(_vm._s(item4))])], 2), _c("span", [_c("a", {
      on: {
        click: function click($event) {
          return _vm.editTarget(index4);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("public.edit")))])]), _c("a-divider", {
      attrs: {
        type: "vertical"
      }
    }), _c("span", [_c("a-popconfirm", {
      attrs: {
        title: _vm.$t("public.deletePromp"),
        "ok-text": _vm.$t("public.confirm"),
        "cancel-text": _vm.$t("public.cancel")
      },
      on: {
        confirm: function confirm($event) {
          return _vm.deleteTarget(index4);
        }
      }
    }, [_c("a", [_vm._v(_vm._s(_vm.$t("public.delete")))])])], 1), _vm.contactDataList.length - 1 == index4 ? _c("span", [_c("a-divider", {
      attrs: {
        type: "vertical"
      }
    }), _c("a", {
      on: {
        click: function click($event) {
          return _vm.addTarget();
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("publicuse.add")))])], 1) : _vm._e()], 1);
  }), 0)]), _c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pagesetting.replayEmail")) + "：")]), _c("div", {
    staticStyle: {
      "padding-right": "60px",
      "flex-direction": "column"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px 0"
    }
  }, [_c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.oldReplyEmailData.replyEmail) + " ")]), _c("span", {
    class: [_vm.oldReplyEmailData.replyEmail ? "catalogStyle" : ""]
  }, [_vm._v(_vm._s(_vm.oldReplyEmailData.replyEmail))])], 2), _c("span", [_c("a", {
    on: {
      click: function click($event) {
        return _vm.editReplyEmail();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.edit")))])])], 1)])])]), _c("a-card", {
    staticStyle: {
      "border-top": "24px solid #f0f2f5"
    },
    attrs: {
      bordered: false,
      title: _vm.$t("pagesetting.title4")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pagesetting.sellerEmail")) + "：")]), _c("div", {
    staticStyle: {
      "padding-right": "60px",
      "flex-direction": "column"
    }
  }, [_c("div", {
    staticStyle: {
      padding: "12px 0"
    }
  }, [_c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.sellerEmail) + " ")]), _c("span", {
    class: [_vm.sellerEmail ? "catalogStyle" : ""]
  }, [_vm._v(_vm._s(_vm.sellerEmail))])], 2), _c("span", [_c("a", {
    on: {
      click: _vm.editSellerEmail
    }
  }, [_vm._v(_vm._s(_vm.$t("public.edit")))])])], 1)])])])], 1), _c("a-modal", {
    attrs: {
      title: _vm.contentTitle,
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.contentVisible,
      callback: function callback($$v) {
        _vm.contentVisible = $$v;
      },
      expression: "contentVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.specValueData
    }
  }, [_vm._l(_vm.specValueData.lineList, function (tempObj, index) {
    return _c("div", {
      key: "lineList" + index
    }, [tempObj.required ? [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName,
        prop: "lineList." + index + ".content",
        rules: [{
          required: true,
          message: _vm.$t("pagesetting.pls"),
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("pagesetting.pls"),
        maxLength: 100
      },
      model: {
        value: tempObj.content,
        callback: function callback($$v) {
          _vm.$set(tempObj, "content", $$v);
        },
        expression: "tempObj.content"
      }
    })], 1)] : [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("pagesetting.pls"),
        maxLength: 100
      },
      model: {
        value: tempObj.content,
        callback: function callback($$v) {
          _vm.$set(tempObj, "content", $$v);
        },
        expression: "tempObj.content"
      }
    })], 1)]], 2);
  }), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("pagesetting.url")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("pagesetting.pls2"),
      maxLength: 100
    },
    model: {
      value: _vm.specValueData.url,
      callback: function callback($$v) {
        _vm.$set(_vm.specValueData, "url", $$v);
      },
      expression: "specValueData.url"
    }
  })], 1)], 2), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _vm.contentTitle == _vm.$t("pagesetting.addContent") ? _c("a-button", {
    attrs: {
      loading: _vm.loadingAdd,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.addSpecValue();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))]) : _vm._e(), _vm.contentTitle == _vm.$t("pagesetting.editContent") ? _c("a-button", {
    attrs: {
      loading: _vm.loadingEdit,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.updateSpecValue();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))]) : _vm._e()], 1)], 2), _c("a-modal", {
    attrs: {
      title: _vm.$t("pagesetting.addtargetEmail"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.targetVisible,
      callback: function callback($$v) {
        _vm.targetVisible = $$v;
      },
      expression: "targetVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.contactData
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("pagesetting.targetEmail")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("pagesetting.pls3"),
      maxLength: 100
    },
    model: {
      value: _vm.contactData.targetEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.contactData, "targetEmail", $$v);
      },
      expression: "contactData.targetEmail"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetContact();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.loadingConadd,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.addEditcontact();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))])], 1)], 2), _c("a-modal", {
    attrs: {
      title: _vm.$t("pagesetting.addreplayEmail"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.replyVisible,
      callback: function callback($$v) {
        _vm.replyVisible = $$v;
      },
      expression: "replyVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.replyEmailData
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("pagesetting.replayEmail")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("pagesetting.pls3"),
      maxLength: 100
    },
    model: {
      value: _vm.replyEmailData.replyEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.replyEmailData, "replyEmail", $$v);
      },
      expression: "replyEmailData.replyEmail"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetReplyEmail();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.loadingConadd,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.addEditReplyEmail();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")) + " ")])], 1)], 2), _c("a-modal", {
    attrs: {
      title: _vm.$t("pagesetting.addLink"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.logVisible,
      callback: function callback($$v) {
        _vm.logVisible = $$v;
      },
      expression: "logVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.logData
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("pagesetting.pdfUrl")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("pagesetting.pls2"),
      maxLength: 100
    },
    model: {
      value: _vm.logData.catalogPdfUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.logData, "catalogPdfUrl", $$v);
      },
      expression: "logData.catalogPdfUrl"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("pagesetting.url2")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("pagesetting.pls2"),
      maxLength: 100
    },
    model: {
      value: _vm.logData.catalogPageUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.logData, "catalogPageUrl", $$v);
      },
      expression: "logData.catalogPageUrl"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetLog();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.loadingLogadd,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.addEditlog();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))])], 1)], 2), _c("a-modal", {
    attrs: {
      title: _vm.$t("pagesetting.editSellerEmailTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.sellerEmailVisible,
      callback: function callback($$v) {
        _vm.sellerEmailVisible = $$v;
      },
      expression: "sellerEmailVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.sellerEmailData
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("pagesetting.sellerEmail")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("pagesetting.pls3"),
      maxLength: 100
    },
    model: {
      value: _vm.sellerEmailData.sellerEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.sellerEmailData, "sellerEmail", $$v);
      },
      expression: "sellerEmailData.sellerEmail"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        _vm.sellerEmailVisible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.loadingConadd,
      type: "primary"
    },
    on: {
      click: _vm.editSellerEmailData
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")) + " ")])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };